import { render } from "./ImgTitle.vue?vue&type=template&id=4f6966d5&scoped=true"
import script from "./ImgTitle.vue?vue&type=script&lang=js"
export * from "./ImgTitle.vue?vue&type=script&lang=js"

import "./ImgTitle.vue?vue&type=style&index=0&id=4f6966d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6966d5"]])

export default __exports__